import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SupplementaryAccountsService } from 'src/app/core/services/supplementary-accounts.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModal implements OnInit {

  @Input() public userId;
  @Input() public enable;
  constructor(
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private supplementaryAccountService: SupplementaryAccountsService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  removeSupUser() {
    if (this.enable) {
      this.enableUser();
      return;
    }
    this.spinner.show();
    this.supplementaryAccountService.delteSupplementaryUser(this.userId).subscribe((response: any) => {
      if (response.success) {
        this.spinner.hide();
        this.activeModal.close(true);
        const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.SUPPLEMENTARY_USER_DELETED_SUCCESSFULLY;
      }
    }, (error: any) => {
      this.spinner.hide();
      // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    })
  }
  enableUser() {
    this.spinner.show();
    this.supplementaryAccountService.enableSa(this.userId).subscribe((response) => {
      this.spinner.hide();
      if (response) {
        this.activeModal.close(true);
        const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.SUPPLEMENTARY_USER_ENABLED_SUCCESSFULLY;
      }
    }, (error) => {
      this.spinner.hide();
    });
  }
  closeDialog() {
    this.activeModal.dismiss();
  }
}
